import React, { useState } from 'react';

import './HomePage.css'

import prepedLogo from './images/PrepedLogo.png';
import heroImage from './images/PrepedHero.png';
import qrImage from './images/PrepedQrCode.png';

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        {children}
      </div>
    </div>
  );
};

const HomePage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isQRModalOpen, setIsQRModalOpen] = useState(false);

  const handleBurgerClick = (e) => {
    setIsMenuOpen(e.target.checked);
  };

  return (
    <div className="container">
      <div className="glass-header">
        <div className="header-content">
          <div className="logo-container">
            <img
              src={prepedLogo}
              alt="Longevity Checklist Logo"
              className="logo-image"
              onClick={() => window.scrollTo(0, 0)}
            />
          </div>

          <div className="header-controls">
            <button
              className="qr-button"
              onClick={() => setIsQRModalOpen(true)}
            >
              {/* <QrCode size={24} /> */}
              <span>Download</span>
            </button>

            <label className="burger" htmlFor="burger">
              <input
                type="checkbox"
                id="burger"
                checked={isMenuOpen}
                onChange={handleBurgerClick}
              />
              <span></span>
              <span></span>
              <span></span>
            </label>
          </div>

          {isMenuOpen && (
            <div className="dropdown-menu">
              {/* <div className="menu-item" onClick={() => window.scrollTo(0, 0)}>Home</div> */}
              <div
                className="menu-item"
                onClick={() => document.querySelector('.features-section').scrollIntoView({ behavior: 'smooth' })}
              >
                Features
              </div>
              <div
                className="menu-item"
                onClick={() => window.open('https://apps.apple.com/us/app/preped-recipes-groceries/id6463457641?itscg=30200&itsct=apps_box_link&mttnsubad=6463457641', '_blank')}
              >
                Download
              </div>
            </div>
          )}
        </div>
      </div>

      <Modal isOpen={isQRModalOpen} onClose={() => setIsQRModalOpen(false)}>
        <div className="qr-container">
          <h2 className="qr-title">Scan to Download</h2>
          <img
            src={qrImage}
            alt="QR Code"
            className="qr-code"
          />
          <p className="qr-description">Scan this QR code with your mobile device to download the app</p>
        </div>
      </Modal>


      <div className="hero-container">
        <div className="hero-wrapper">
          <div className="hero-text-content">
            <h1 className="hero-title">create ∞ recipes</h1>
            <p className="hero-description">
            Literally any recipe you can think of, created in seconds
            </p>
            <a
              href="https://apps.apple.com/us/app/preped-recipes-groceries/id6463457641?itscg=30200&itsct=apps_box_link&mttnsubad=6463457641"
              style={styles.appStoreButtonContainer}
            >
              <img
                src="https://toolbox.marketingtools.apple.com/api/v2/badges/download-on-the-app-store/black/en-us?releaseDate=1730073600"
                alt="Download on the App Store"
                style={styles.appStoreButtonOfficial}
              />
            </a>
          </div>
          <div className="hero-image-container">
            <img
              src={heroImage}
              alt="Longevity Checklist"
              className="hero-image"
            />
          </div>
        </div>

        <div className="features-section">
          <h3 className="features-title">Features</h3>
          <div className="features-cards">
            <div className="feature-card">
              <h4>Recipe Suggestions</h4>
              <p>Recipe suggestions if you can't think of what you want</p>
            </div>
            <div className="feature-card">
              <h4>Create Recipe</h4>
              <p>Generate any recipe you can imagine in seconds</p>
            </div>
            <div className="feature-card">
              <h4>Shopping List</h4>
              <p>Instantly import the ingredients for any of your saved recipes in to shopping list</p>
            </div>
          </div>
          {/* <p className="cta-text">Start Your Longevity Journey Today!</p> */}
        </div>
      </div>

      <footer className="footer">
        <div className="footer-container">
          {/* <div className="footer-section">
            <h4>About</h4>
            <p></p>
          </div>
          <div className="footer-section">
            <h4>Contact</h4>
            <p>Email: </p>
            <p>Phone: </p>
          </div> */}
          {/* <div className="footer-section">
            <h4>Follow Us</h4>
            <div className="social-icons">
              <a href="#"><img src="path/to/facebook-icon.png" alt="Facebook" /></a>
              <a href="#"><img src="path/to/twitter-icon.png" alt="Twitter" /></a>
              <a href="#"><img src="path/to/instagram-icon.png" alt="Instagram" /></a>
            </div>
          </div> */}
        </div>
        <p className="footer-credits">© 2025 15086357 Canada Inc. All Rights Reserved.</p>
      </footer>
    </div>
  );
};

const styles = {
  appStoreButtonContainer: {
    marginBottom: '20px',
  },
  appStoreButtonOfficial: {
    width: '170px',
    height: 'auto',
  }
};

export default HomePage;